<template>
  <div
    class="wrapper-action row no-margin"
    @click="setPosSection('tables')">
    <div
      v-if="tableInfo || table_number"
      class="col status selected text-success">
      <strong v-if="tableInfo">
        <i
          class="fas fa-check"
          style="margin-right: 3px;"/>
        <!-- {{ tableInfo.table_number }} -->
        {{ $t('apps.pos.message.tablenumber', {ref_name: refName, number: tableInfo.table_number}) }}
      </strong>
      <strong v-if="!tableInfo && table_number">
        <i
          class="fas fa-check"
          style="margin-right: 3px;"/>
        <!-- Table {{ table_number }} -->
        {{ $t('apps.pos.message.tablenumber', {ref_name: refName, number: table_number}) }}
      </strong>
    </div>
    <div
      v-if="!tableInfo && !table_number"
      class="col status">
      <strong>
        {{ refName }}
      </strong>
    </div>
    <div class="col text-right available">
      <i class="fas fa-angle-right"/>
    </div>
  </div>
</template>

<script>
import tableButtonMixin from '@/mixins/pos/tableButton'

export default {
  mixins: [tableButtonMixin],
}
</script>

<style scoped>
  .wrapper-action {
    padding: 13px 0;
    border-bottom: solid 1px #F2F2F2;
    font-size: 14px;
    color: #6C7A86;
    cursor: pointer;
  }
  .wrapper-action .status {
    padding-right: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    height: auto;
    white-space: nowrap;
  }
  .wrapper-action .available {
    padding-left: 0;
  }
  .wrapper-action .available i.fa-angle-right {
    position: relative;
    top: 1px;
    margin-left: 6px;
  }
  div.selected {

  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/TableButton.vue